module.exports = __webpack_public_path__ + "static/Garden2-619719ab031e485f4fbfb0cd74f85df2.jpeg";